import React, { createContext, useContext, useState, ReactNode } from 'react';
import { t, Language } from './translations';

interface LangContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  tr: typeof t.es;
}

const LangContext = createContext<LangContextType | undefined>(undefined);

export function LangProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Language>('es');

  return (
    <LangContext.Provider value={{ lang, setLang, tr: t[lang] }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const context = useContext(LangContext);
  if (context === undefined) {
    throw new Error('useLang must be used within a LangProvider');
  }
  return context;
}
